'use client';
import { Alert } from '@//components/Alert';

interface NoSearchResultProps {
  q: string | null;
}

const NoSearchResult = ({ q }: NoSearchResultProps) => (
  <Alert id="no-retailers-found" variant="caution" heading="Ingen återförsäljare hittades">
    Ingen återförsäljare hittades vid sökning på &quot;{q}&quot;.
  </Alert>
);

export default NoSearchResult;
